<template>
  <transition
    :name="transition"
    mode="in-out"
    appear
    :appear-active-class="enterClass"
    :enter-active-class="enterClass"
    :leave-active-class="leaveClass"
  >
    <div v-if="show">
      <div class="alert-modal-background" @click="deactive"></div>
      <div class="alert-modal-card" :style="style">
        <div class="alert-modal-card-rap">
          <section class="alert-modal-card-body" :class="body_class">
            <p>{{ title }}</p>
            <div>{{content}}</div>
          </section>
          <section class="alert-modal-card-bottom">
            <button v-if="(ok_cb != null)" class="btn-ng" @click="cancel">{{$st('alert_no')}}</button>
            <button class="btn-ok" @click="ok">{{$st('alert_yes')}}</button>
          </section>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AlertModal',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
    content: {
      type: String,
    },
    ok_cb: {
      type: Function,
    },
    ng_cb: {
      type: Function,
    },
    type: {
      type: String,
    },
    visible: Boolean,
    transition: {
      type: String,
      default: 'fade',
    }
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      show: this.visible,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    title () {
      if (this.type === 'alert') {
        return this.$st('alert_title');
      } else if (this.type === 'warning') {
        return this.$st('alert_title');
      }
      return this.$st('alert_title');
    },
    body_class () {
      if (this.type === 'alert') {
        return 'alert-body-class';
      } else if (this.type === 'warning') {
        return 'warning-body-class';
      }
      return 'info-body-class';
    },
    style () {
      return '';
    },
    enterClass () {
      return `${this.transition}In`;
    },

    leaveClass () {
      return `${this.transition}Out`;
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    this.$lib._$id('alert_layer').appendChild(this.$el);
    this.$lib._$id('alert_layer').style.display = 'block';
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    ok () {
      if (this.ok_cb !== null) {
        this.ok_cb();
      }
      this.remove();
    },

    cancel () {
      if (this.ng_cb !== null) {
        this.ng_cb();
      }
      this.remove();
    },

    active () {
      this.show = true;
    },

    deactive () {
      this.show = false;
      this.remove();
    },

    remove () {
      this.$lib._$id('alert_layer').removeChild(this.$el);
      this.$lib._$id('alert_layer').style.display = 'none';
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
    visible (val) {
      this.show = val;
    }
  },
};
</script>

<style lang="scss">
.alert-modal-card {
  margin-top: calc(50vh - 150px);

  .alert-modal-card-bottom {
    width: 75%;
    margin: 0 auto;
    color: #fefefe;
  }
  .alert-modal-card-body {
    padding: 20px 0;
    p {
      width: 70%;
      margin: 0 auto;
      white-space: pre;
      padding: 0px 0px 8px 0px;
      font-weight: bold;
    }
    div {
      width: 70%;
      height: 100px;
      margin: 0 auto;
      white-space: pre;
      font-weight: 400;
      overflow-y: auto;
      white-space: pre-wrap;
      padding: 8px 0px 0px 0px;
    }
  }
  .alert-body-class {
    background-color: #ffd6d5;
    p {
      border-bottom: 1px solid #ad4240;
    }
    p, div {
      color: #ad4240;
    }
  }
  .info-body-class {
    background-color: #fff6d5;
    p {
      border-bottom: 1px solid #5e413f;
    }
    p, div {
      color: #5e413f;
    }
  }
  .warning-body-class {
    border-top: 1px solid #ffd22e;
    border-bottom: 1px solid #ffd22e;
  }
  .alert-modal-card-title {
    font-size: 28px;
    margin: 0;
  }
  .alert-modal-card-bottom {
    padding: 24px 0;
    text-align: center;
    button {
      border: none;
      color: #fefefe;
      width: 180px;
      text-align: center;
      padding: 8px;
      margin-right: 10px;
      font-size: 18px;
      border-radius: 5px;
    }
    button:last-child {
      margin-right: 0px;
    }
    .btn-ok {
      color: #fefefe;
      border: 2px solid #a24644;
      background: #da7272;
    }
    .btn-ok:hover {
      background: #9f3e3c;
    }
    .btn-ng {
      color: #fefefe;
      border: 2px solid #595454;
      background: #9b9292;
    }
    .btn-ng:hover {
      background: #4e4949;
    }
  }
  @media (max-width: 767px) {
    .alert-modal-card-bottom {
      width: 85%;
    }
    .alert-modal-card-bottom {
      button {
        width: 120px;
      }
    }
  }
}
</style>
